import React from "react"
import { DateRangePickerSeeker, disabledAfterToday } from "@ui-seeker/core"


export default function BatchDateFilter({ onChange, value }) {
	return <DateRangePickerSeeker
		label="Date Range"
		shouldDisableDate={disabledAfterToday()}
		value={value}
		onChange={onChange}
		preventOverflow={false}
		placement="bottomEnd"
		inputProps={{ sx: { backgroundColor: "background.grey" } }}
		containerProps={{
			width: 1000,
			sx: {
				'.rs-picker-daterange': {
					height: 2,
					width: 240
				},
			}
		}}
	/>
}